import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { getColorForAvailabilityType } from '../helpers/get-color-for-availability-type';
import { getUnavailabilityColor } from '../helpers/get-unavailability-color';

export type AvailabilityLegendItem = {
  key: string;
  label: string;
  color: string;
};

export const useAvailabilityLegendItems = (): AvailabilityLegendItem[] => {
  const { t } = useTranslation('all-platforms-common');
  const theme = useTheme();
  const { allowWorkerUnavailability } = useFeatureFlagContext();

  return useMemo(
    () => [
      {
        key: 'available',
        label: t('availability_page.worker_available'),
        color: getColorForAvailabilityType('available', 0.5),
      },
      {
        key: 'pending',
        label: t('availability_page.worker_pending'),
        color: getColorForAvailabilityType('pending', 0.5),
      },
      {
        key: 'tentative',
        label: t('availability_page.worker_tentative'),
        color: getColorForAvailabilityType('tentative', 0.5),
      },
      {
        key: 'blocked',
        label: t('availability_page.worker_blocked'),
        color: getColorForAvailabilityType('blocked', 0.5),
      },
      ...(allowWorkerUnavailability
        ? [
            {
              key: 'unavailable',
              label: t('availability-page.legend.unavailable'),
              color: getUnavailabilityColor(theme),
            },
          ]
        : []),
    ],
    [allowWorkerUnavailability, t, theme]
  );
};
